import { FuelSurchargeRangeDto } from 'common/api/dto/rates.dto';
import currency from 'currency.js';
import { useMemo, useState } from 'react';
import { Column } from 'react-table';
import {
  CenteredHeader,
  CenteredText,
} from '../components/Sub-views/RatesView/Tabs/styles';
import {
  perBinStr,
  perLoadStr,
} from '../components/Sub-views/RatesView/Tabs/Surcharges';
import {
  RateFormProps,
  TableRateInput,
} from '../components/Sub-views/RatesView/Tabs/TableRateInput';
import { createSurchargeKey } from '../components/Sub-views/RatesView/utils/functions';

export type SurchagesTableRows = {
  range: string;
  perBin: RateFormProps;
  perLoad: RateFormProps;
};

export const useSurchargesTableData: {
  (
    rows: FuelSurchargeRangeDto[],
    isSubmitting: boolean,
  ): {
    columns: Column<SurchagesTableRows>[];
    data: SurchagesTableRows[];
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
  };
} = (rows, isSubmitting) => {
  const [isEditing, setIsEditing] = useState(false);

  const columns: Column<SurchagesTableRows>[] = useMemo(
    () => [
      {
        Header: () => <CenteredHeader>Range</CenteredHeader>,
        accessor: 'range',
        width: '33%',
        Cell: ({ value }) => <CenteredText>{value}</CenteredText>,
      },
      {
        Header: () => <CenteredHeader>Per Bin</CenteredHeader>,
        accessor: 'perBin',
        width: '33.5%',
        Cell: ({ value }) => (
          <TableRateInput
            showInput={isEditing}
            value={value}
            isSubmitting={isSubmitting}
          />
        ),
      },
      {
        Header: () => <CenteredHeader>Per Load</CenteredHeader>,
        accessor: 'perLoad',
        width: '33.5%',
        Cell: ({ value }) => (
          <TableRateInput
            showInput={isEditing}
            value={value}
            isSubmitting={isSubmitting}
          />
        ),
      },
    ],
    [isEditing, isSubmitting],
  );

  const data: SurchagesTableRows[] = useMemo(() => {
    return rows.map(row => ({
      range: `${row.miles} miles`,
      perBin: {
        formValueKey: createSurchargeKey(
          perBinStr,
          row.haulLabelId,
          row.surchargeId,
        ),
        displayValue: row.perBin ? currency(row.perBin).format() : '$0',
      },
      perLoad: {
        formValueKey: createSurchargeKey(
          perLoadStr,
          row.haulLabelId,
          row.surchargeId,
        ),
        displayValue: row.perLoad ? currency(row.perLoad).format() : '$0',
      },
    }));
  }, [rows]);

  return {
    columns,
    data,
    isEditing,
    setIsEditing,
  };
};
